const de = {
  title: 'Zugangskontrolle'
};

export default de;
export type AccessHandlerTranslation = typeof de;
